/**
 * A simple store in local-memory
 */
class Store {
    /**
     * Preserve values in the store with a key
     * e.g [{ key: 'key', value: {} }]
     *
     * Note: Not to be confused with state (@see this.state)
     *
     * @type {object}
     */
    store = [];

    /**
     * Store a value in the store
     *
     * @param {string} key
     * @param {mixed} value
     * @return array The store
     */
    setEntry = (key, value) => {
        if (this.getEntry(key)) {
            // Clear the existing entry
            this.deleteEntry(key);
        }

        this.store.push({
            key: key,
            value: value,
        });

        return this.store;
    };

    /**
     * Get an entry from the store
     *
     * @param {string} key
     * @returns {Store} this
     */
    getEntry = (key) => {
        const entry = this.store.filter((obj) => obj.key === key);

        return entry.length ? entry[0].value : null;
    };

    /**
     * Delete an entry from the store
     *
     * @param {string} key
     * @returns {Store} this
     */
    deleteEntry = (key) => {
        const index = this.store.findIndex((obj) => obj.key === key);

        if (index >= 0) {
            this.store = [
                ...this.store.slice(0, index),
                ...this.store.slice(index + 1),
            ];
        }

        return this;
    };
}

export default new Store();
